import api from './Api';

export interface IEmpresaConciliacaoConfig {
    id: number;
    empresaID: number;
    tipoConciliacao: string;
    modo: 'DETERMINISTICO' | 'LLM' | string;
    vigenciaInicio: string;
    vigenciaFim: string | null;
    ativo: boolean;
    dataCadastro: string;
    dataAlteracao: string | null;
}

export interface IEmpresaConciliacaoConfigRequest {
    empresaId: number;
    tipoConciliacao: string;
    modo: string;
    vigenciaInicio: string;
    vigenciaFim: string | null;
}

const EmpresaConciliacaoConfigService = {
    listarPorEmpresa: async (empresaId: number): Promise<IEmpresaConciliacaoConfig[]> => {
        const resp = await api.get(`EmpresaConciliacaoConfig/empresa/${empresaId}`);
        return resp.data;
    },

    criar: async (request: IEmpresaConciliacaoConfigRequest): Promise<IEmpresaConciliacaoConfig> => {
        const resp = await api.post('EmpresaConciliacaoConfig', request);
        return resp.data;
    },

    atualizar: async (id: number, request: IEmpresaConciliacaoConfigRequest): Promise<IEmpresaConciliacaoConfig> => {
        const resp = await api.put(`EmpresaConciliacaoConfig/${id}`, request);
        return resp.data;
    },

    desativar: async (id: number): Promise<void> => {
        await api.delete(`EmpresaConciliacaoConfig/${id}`);
    }
};

export default EmpresaConciliacaoConfigService;
